import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";
import styles from "./accordion.module.css";
var AccordionContent = function(param) {
    var isExpanded = param.isExpanded, id = param.id, content = param.content, sectionId = param.sectionId, buttonId = param.buttonId;
    var ref = useState(0), height = ref[0], setHeight = ref[1];
    var ref1 = useState("none"), display = ref1[0], setDisplay = ref1[1];
    var innerContainerRef = useRef(null);
    useEffect(function() {
        var handleResize = function() {
            if (height > 0) {
                onEntered();
            }
        };
        window.addEventListener("resize", handleResize, {
            passive: true
        });
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, [
        height
    ]);
    var onEntering = function() {
        setDisplay("block");
    };
    var onEntered = function() {
        if (innerContainerRef.current) {
            setHeight(innerContainerRef.current.offsetHeight);
        }
    };
    var onExiting = function() {
        setHeight(0);
    };
    var onExit = function() {
        setDisplay("none");
    };
    return /*#__PURE__*/ _jsx(CSSTransition, {
        in: isExpanded,
        timeout: 200,
        onEntering: onEntering,
        onEntered: onEntered,
        onExiting: onExiting,
        onExit: onExit,
        "aria-hidden": !isExpanded,
        role: "region",
        id: "".concat(sectionId, "-").concat(id),
        "aria-labelledby": "".concat(buttonId, "-").concat(id),
        "data-testid": "".concat(sectionId, "-").concat(id),
        className: classnames(styles.accordionContentContainer),
        style: {
            height: height
        },
        children: /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("div", {
                ref: innerContainerRef,
                style: {
                    display: display
                },
                className: classnames(styles.accordionContentInnerContainer),
                children: content()
            })
        })
    });
};
export default AccordionContent;
